import { createContext, useContext, useState, useCallback } from 'react';

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [toast, setToast] = useState({ show: false, msg: '' });

  const showToast = useCallback((msg) => {
    setToast({ show: true, msg });
    setTimeout(() => setToast({ show: false, msg: '' }), 3000);
  }, []);

  const addToCart = useCallback((product) => {
    setCart(prev => {
      const existing = prev.find(i => i.id === product.id);
      if (existing) return prev.map(i => i.id === product.id ? { ...i, qty: i.qty + 1 } : i);
      return [...prev, { ...product, qty: 1 }];
    });
    showToast(`🛒 ${product.name} added to cart!`);
  }, [showToast]);

  const removeFromCart = useCallback((id) => {
    setCart(prev => prev.filter(i => i.id !== id));
  }, []);

  const changeQty = useCallback((id, delta) => {
    setCart(prev => {
      const updated = prev.map(i => i.id === id ? { ...i, qty: i.qty + delta } : i);
      return updated.filter(i => i.qty > 0);
    });
  }, []);

  const totalItems = cart.reduce((s, i) => s + i.qty, 0);
  const totalPrice = cart.reduce((s, i) => s + i.price * i.qty, 0);

  const openCart  = () => { setIsOpen(true);  document.body.style.overflow = 'hidden'; };
  const closeCart = () => { setIsOpen(false); document.body.style.overflow = '';       };

  const orderWhatsApp = () => {
    if (!cart.length) return;
    const items = cart.map(i => `• ${i.name} x${i.qty} = $${i.price * i.qty}`).join('%0A');
    const msg = `Hi Last! I'd like to place an order:%0A%0A${items}%0A%0A*TOTAL: $${totalPrice}*%0A%0APlease confirm availability and delivery.`;
    window.open(`https://wa.me/263713508064?text=${msg}`, '_blank');
  };

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, changeQty, totalItems, totalPrice, isOpen, openCart, closeCart, orderWhatsApp, toast }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
